// extracted by mini-css-extract-plugin
export var active = "_96-b";
export var activeIndicator = "_96-6";
export var animate = "_96-a";
export var disabled = "_96-c";
export var flat = "_96-1";
export var fullWidth = "_96-3";
export var lg = "_96-9";
export var md = "_96-8";
export var redoButtonTabGroup = "_96-0";
export var sm = "_96-7";
export var tabButton = "_96-4";
export var tabButtonsContainer = "_96-2";
export var xs = "_96-5";